const PaymentPatterns = Object.freeze({
    SINGLE: 'SINGLE',
});

module.exports = PaymentPatterns;
